export const styles = {
  rowEllipsis: {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
  },
  table: { column2: { flex: 1 }, column3: { textAlign: 'right' } },
  retryButton: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginLeft: 'auto',
    whiteSpace: 'nowrap',
  },
};
